// gloss
const LABEL_COLLATION: Intl.CollatorOptions = { sensitivity: 'base', numeric: true };

// gloss
export const alphabetical = <T extends { label: string; group?: string }>(options: readonly T[]): T[] =>
  [...options].sort(
    (a, b) =>
      (a.group ?? '').localeCompare(b.group ?? '', undefined, LABEL_COLLATION) ||
      a.label.localeCompare(b.label, undefined, LABEL_COLLATION),
  );
